var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{on:{"click":_vm.fetch}},[_c('label',{class:{'border border-primary border-solid border-2': _vm.isSelected},style:(("background-color: #" + _vm.hex))})])}
var staticRenderFns = []

export { render, staticRenderFns }